module.exports = __webpack_public_path__ + "img/concord-img_medium.efa79e85.jpg";